module.exports = __webpack_public_path__ + "img/brigitte-courtade.5da911a9.jpg";